import React from "react";
import { canSubmitUniversalSignup } from "@/lib/signupNiches";

export default function SignupNicheSelect({
  niches = [],
  value = null,
  onChange,
  family = null,
  catalogStatus = "loading",
  errorMessage = "",
  onRetry,
  selectId = "signup-niche",
  disabled = false,
}) {
  const selectionDisabled = disabled || catalogStatus === "loading";
  const submitReady = canSubmitUniversalSignup({
    catalogStatus,
    nicheId: family === "real_estate" ? null : value,
    niches,
  });

  return (
    <div className="quiet-field" data-universal-submit={submitReady ? "available" : "unavailable"}>
      <label htmlFor={selectId} className="quiet-field-label">
        Niche
      </label>
      <div className="quiet-select-wrap">
        <select
          id={selectId}
          name="niche"
          className="quiet-select"
          value={value || ""}
          onChange={(event) => {
            if (!selectionDisabled) onChange(event.target.value || null);
          }}
          disabled={selectionDisabled}
        >
          <option value="">Choose a niche</option>
          {niches.map((row) => (
            <option key={row.niche_id} value={row.niche_id}>
              {row.label}
            </option>
          ))}
        </select>
      </div>
      {catalogStatus === "error" ? (
        <div>
          <p role="alert">{errorMessage}</p>
          <button type="button" onClick={onRetry} disabled={disabled} data-testid="signup-niche-retry">
            Retry
          </button>
        </div>
      ) : null}
    </div>
  );
}
